import Coverage from '@/modules/common/common/models/MID/Coverage'

export default class PetsRaterPriceInsuredToSave {
  /** Orden del asegurado. Ejemplo: "1". (Obligatorio, Integer). */
  riskNumber: string

  /** Nombre de la mascota. Ejemplo: "Orion". (Obligatorio, String). */
  petName: string

  /** Listado de coberturas. (Obligatorio). */
  coverages: Coverage[]

  constructor(data: any) {
    this.riskNumber = data.riskNumber
    this.petName = data.petName
    this.coverages = data.coverages?.map((c: any) => new Coverage(c))
  }
}
